import moment from "moment";
import {environment} from "environments";

(() => {
  class UserSubscriptionsController {
    constructor($scope, $rootScope, $timeout, toastr, Users, Notifications, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        toastr,
        Users,
        Notifications,
        ngDialog,
        BOD_550: ['dev', 'localhost', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
      });
    }

    $onInit() {
      this.getSubscriptions();
    }

    updateCard() {
      this.$rootScope.$broadcast('select-tab:payment-methods');
    }

    reprocessPayment(subscription_charge_id) {
      this.processing = true;

      if (this.BOD_550) {
        this.Users.reprocessPayment(this.user.id, subscription_charge_id)
          .then(() => {
            this.toastr.success('Payment was reprocessed successfully.');
            this.getSubscriptions();
          })
          .catch((err) => {
            this.processing = false;

            let error = '';
            if (err && err.data && err.data.message && err.data.message.summary) error = err.data.message.summary;
            this.toastr.error(`Error reprocessing payment${ error ? (`: ${ error}`) : '.'}`);
          })
      } else if (!this.BOD_550) {
        this.Users.reprocessPayment(this.user.id, subscription_charge_id)
          .then(() => {
            this.toastr.success('Payment was reprocessed successfully.');
            this.getSubscriptions();
          })
          .catch((err) => {
          }).catch(err => {
          this.processing = false;

          let error = '';
          if (err && err.data && err.data.message && err.data.message.summary) error = err.data.message.summary;
          this.toastr.error(`Error reprocessing payment${ error ? (`: ${ error}`) : '.'}`);

          // JUST FOR TESTING:

          // this.$timeout(() => {
          //   this.processing = false;
          // }, 2000);
        });
      }
    }

    cancelSubscription(subscription) {
      this.openCancelSubscriptionModal(subscription.calculated_cancellation_date, (response) => {
        if (response && response != '$closeButton') {
          this.Users.cancelSubscription(this.user.id, subscription.user_category_subscription_xref_id, response)
          .then(() => {
            this.toastr.success('Membership was cancelled successfully.');
            this.getSubscriptions();
          })
          .catch((err) => {
            let error = '';
            if (err && err.data && err.data.message && err.data.message.summary) error = err.data.message.summary;
            this.toastr.error(`Error cancelling membership${ error ? (`: ${ error}`) : '.'}`);
          });
        } else {
          // Do nothing
          // If user closes the popup
        }
      });
    }

    openCancelSubscriptionModal(calculated_cancellation_date, callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/confirm-subscription-cancellation/confirm-subscription-cancellation.html',
        // To not allow the user closes the modal without explicitely to have some action
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'ConfirmSubscriptionCancellationController',
        controllerAs: 'vm',
        data: {
          calculated_cancellation_date
        },

        preCloseCallback(response) {
          return callback(response);
        }

      });
    }

    getSubscriptions() {
      this.Users.getSubscriptions(this.user.id)
      .then(({ data }) => {
        this.setup(data);
        this.processing = false;
      })
      .catch((err) => {
        this.subscriptions = [];
        this.processing = false;
      });
    }

    setup(subscriptions) {
      /*

      ACCORDING TO THE DESIGN:

        "Enrolled" <= Membership "open"

        "User canceled" <= Membership "cancelled"

        "Failed payment, call patient" <= Membership "open" + latest charge / charges[0] not "settled" ("failed" or "open" or ANY)

        "Canceled, failed payment" <= Membership "cancelled" + latest charge / charges[0] not "settled" ("failed" or "open" or ANY)

        "Completed treatment" <= Membership "completed"

      */

      subscriptions.forEach((subscription) => {
        // By default all Memberships are collapsed
        subscription.hideUpdate = true;

        subscription.hideReprocess = true;
        subscription.collapsed = true;
        subscription.status_color = 'gray';

        let thereIsChargeNotSettled = false;
        let thereIsFailedPayment = false;
        let thereIsCancelledPayment = false;

        if (subscription.charges && subscription.charges.length) {
          subscription.charges.forEach((charge) => {
            // TEMPORARY HARDCODED FIX UNTIL CHARUL FIXES
            if (charge.status == 'success') charge.status = 'settled';


            if (charge.status != 'settled') thereIsChargeNotSettled = true;
          });
        }
        if (subscription.charges && subscription.charges.length) {
          if (subscription.charges[0].status == 'failed') {
            thereIsFailedPayment = true;
          }

          if (subscription.charges[0].status == 'cancelled') {
            thereIsCancelledPayment = true;
          }
        }


        if (subscription.status == 'open') {
          if (thereIsFailedPayment) {
            subscription.display_status = 'Failed payment, call patient';
            subscription.status_color = 'red';
          } else {
            subscription.display_status = 'Enrolled';
            subscription.status_color = 'blue';
          }
        }

        if (subscription.status == 'cancelled') {
          if (thereIsCancelledPayment) {
            subscription.display_status = 'Canceled, failed payment';
            subscription.showUpdate = false;
            subscription.showReprocess = false;
            subscription.hideUpdate = false;
            subscription.hideReprocess = false;
          } else {
            subscription.display_status = 'User canceled';
          }
        }

        // FE FIX FOR A BE ISSUE: https://23andme.atlassian.net/browse/LMNUK-79
        if (moment(subscription.active_end_date).isBefore(moment())) {
          subscription.display_status = subscription.cancel_reason ? `Cancelled, ${subscription.cancel_reason.display_name}` : 'Expired';
        }


        if (subscription.status == 'completed') subscription.display_status = 'Completed treatment';
      });
      this.subscriptions = subscriptions;
    }

  }

  UserSubscriptionsController.$inject = ["$scope", "$rootScope", "$timeout", "toastr", "Users", "Notifications", "ngDialog"];
  angular.module('pims').component('userSubscriptions', {
    templateUrl: 'app/views/users/detail/tabs/subscriptions/subscriptions.tab.html',
    controller: UserSubscriptionsController,
    controllerAs: 'vm',
    bindings: {
      user: '<'
    }
  });
})();
